import {
  black,
  yellow50, yellow200, yellow400, yellow700,
  lightBlue50, lightBlue200, lightBlue400, lightBlue700,
  grey300, grey500, grey700,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import {fade} from 'material-ui/utils/colorManipulator';
import spacing from 'material-ui/styles/spacing';

/**
 *  Light Theme is the default theme used in material-products. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
export default {
  spacing,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: yellow700,
    primary2Color: yellow400,
    primary3Color: yellow50,
    accent1Color: darkBlack,
    accent2Color: black,
    accent3Color: fullBlack,
    textColor: fullBlack,
    secondaryTextColor: fade(darkBlack, 0.54),
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: yellow200,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
  },
};



// WEBPACK FOOTER //
// ./containers/themes/multuTheme.js